import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import { portal } from './react-portals';

var PortalCore =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PortalCore, _PureComponent);

  function PortalCore() {
    _classCallCheck(this, PortalCore);

    return _possibleConstructorReturn(this, _getPrototypeOf(PortalCore).apply(this, arguments));
  }

  _createClass(PortalCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.updateChild(this.props.children);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.updateChild(this.props.children);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.updateChild(null);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return PortalCore;
}(PureComponent);

var Portal =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(Portal, _PureComponent2);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this, props));
    _this.Portal = portal(props.target, 'updateChild', props.portalId)(PortalCore);
    return _this;
  }

  _createClass(Portal, [{
    key: "render",
    value: function render() {
      var Portal = this.Portal;
      return React.createElement(Portal, this.props);
    }
  }]);

  return Portal;
}(PureComponent);

_defineProperty(Portal, "propTypes", {
  /**
   * key used for react reconciliation
   */
  portalId: propTypes.string,

  /**
   * name of the PortalTarget to portal in to
   */
  target: propTypes.string
});

export default Portal;